"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { campaignFromUrl, saveCampaign } from "@/lib/campaign";

/**
 * Records a page load that arrived with utm_* parameters (the poster QR code, ads) and keeps the
 * parameters for the beta form. Renders nothing. Mounted once in the root layout.
 */
export function CampaignCapture() {
  const pathname = usePathname();

  useEffect(() => {
    const c = campaignFromUrl();
    if (!c) return;
    saveCampaign(c);
    void fetch("/api/marketing/campaign-visit", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        utmSource: c.utmSource,
        utmMedium: c.utmMedium,
        utmCampaign: c.utmCampaign,
        path: c.landingPath,
        referrer: c.referrer,
      }),
      keepalive: true,
    }).catch(() => {});
  }, [pathname]);

  return null;
}
